import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { RoleAssignmentStaff } from "./RoleAssignmentStaff";
import type { RoleDTOBase } from "./RoleDTOBase";
import type { RolePermissionStaff } from "./RolePermissionStaff";

export class RoleStaff implements RoleDTOBase {
  constructor(public readonly roleId: number, public readonly roleName: string | null, public readonly permissions: Array<RolePermissionStaff> | null, public readonly assignments: Array<RoleAssignmentStaff> | null) {
    this.cbiServiceContext = null;
    this.permissionsLoaded = this.permissions != null;
    this.permissionsCached = this.permissions;
    this.assignmentsLoaded = this.assignments != null;
    this.assignmentsCached = this.assignments;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private permissionsLoaded: boolean;
  private permissionsCached: Array<RolePermissionStaff> | null;
  private assignmentsLoaded: boolean;
  private assignmentsCached: Array<RoleAssignmentStaff> | null;
  async permissionsLazy(): Promise<Array<RolePermissionStaff>> {
    if (!this.permissionsLoaded) {
      this.permissionsCached = await this.cbiServiceContext!.permissionService().getRoleStaffPermissions(this.roleId);
      this.permissionsLoaded = true;
    }
    return this.permissionsCached!;
  }
  async assignmentsLazy(): Promise<Array<RoleAssignmentStaff>> {
    if (!this.assignmentsLoaded) {
      this.assignmentsCached = await this.cbiServiceContext!.permissionService().getRoleStaffAssignments(this.roleId);
      this.assignmentsLoaded = true;
    }
    return this.assignmentsCached!;
  }
}
